import { useSelector } from "react-redux";
import TabHeader from "../../../../../../common/DroppedFileList/components/TabHeader";
import ActionButton from "../../../../../../common/ActionButton/ActionButton";
import DownloadIcon from "../../../../../../Icon-SVG/DownloadIcon";

const IocsContent = ({ activeMenu, iocs }) => {
  const generalInfo = useSelector((state) => state.analysisReports.general);

  // Only an empty list has nothing to download. (This used to read
  // `iocs || ...`, which is always true for the iocs object, so the button
  // was permanently disabled.)
  const isDisabled = !iocs?.[activeMenu.id]?.length;

  const downloadHandler = () => {
    const blob = new Blob([iocs[activeMenu.id].join("\n")], {
      type: "plain/text",
    });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `CFSBOX_IOC_${activeMenu.header}_${generalInfo?.sha1}.txt`;
    document.body.appendChild(a);
    a.click();

    URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  return (
    <div className="iocs__content">
      <div className="iocs__content__header">
        <h3>{activeMenu.header}</h3>
        <ActionButton
          icon={<DownloadIcon width={13} height={13} color="currentColor" />}
          disabled={isDisabled}
          onClick={downloadHandler}>
          Download
        </ActionButton>
      </div>

      <div className="iocs__content__mid">
        <p>{activeMenu.description}</p>
      </div>

      <div className="iocs__content__bottom">
        <div className="iocs__content__table">
          <TabHeader active={true} setActive={() => {}} />
          <div className="iocs__content__list">
            {Object.keys(iocs).length > 0 && iocs[activeMenu.id].length > 0 ? (
              iocs[activeMenu.id]?.map((ioc, i) => (
                <p className="iocs__content__row" key={i}>
                  {ioc}
                </p>
              ))
            ) : (
              <p className="iocs__content__no-data">No data</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IocsContent;
